module.exports = __webpack_public_path__ + "static/media/photo-right-third.7f048475.png";